export default [
    'Cold Storage',
    'Data Center',
    'Distribution',
    'Flex',
    'Logistics',
    'Manufacturing',
    'Owner-User',
    'Other',
    'Research & Development',
    'Showroom',
    'Vacant',
    'Warehouse'
];